varying float vCarrierDistance;
uniform vec3 uCarrierPosition;
varying vec3 vPositionW;

void main() {
  float dist = max(1. - vCarrierDistance * 5.5, 0.);
  dist = pow(dist, 2.5);
  dist = max(0.005, dist);
  csm_DiffuseColor = vec4(vec3(csm_DiffuseColor * 2.), min(dist * 1. * opacity, 1.));
  // csm_DiffuseColor = vec4(vec3(csm_DiffuseColor), 1.1);
}